import CopyButton from './copy-button';

/**
 * Placeholder sharing menu logic until more advanced functionality is required
 */
export default class SharingMenu {
    /**
     * Initializes the menu functionality
     * @param {Element} el The element on which to initialize the menu
     */
    constructor(el) {
        this.el = el;
        this.buttons = el.querySelectorAll('.sharing-menu__button');

        // Initialize individual button actions
        this.buttons.forEach(btn => {
            if (btn.classList.contains('sharing-menu__button--copy')) {
                new CopyButton(btn, btn.getAttribute('href'));
            }
        });
    }
}
